import { connect } from 'react-redux';
import { State } from 'store/state';
import { activeInsightIdSelector } from 'store/state/insightsContext/selectors';
import { HoodPage } from './HoodPage';
import {
  resolvedLocalPageSelector,
  resolvedStrictLocalDocSelector,
  searchListTotalSelector,
  localPageMadadAgenciesCardsSelector,
  isSearchListLoadingSelector,
} from 'store/state/domainData/selectors';
import { listingPoiSelector } from 'store/state/selectors/searchListView';
import { routeSelector } from 'store/state/selectors/router';
import { pricesItemsCountSelector } from 'store/state/selectors/insights/prices';
import { articlesSelector } from 'components/blog-carousel/area-page';
import { leadingAgentsByDocIdsSelector } from 'store/state/domainData/selectors/searchAgentAwardsByDocIds';
import { LeadingAgentFeature } from 'utils/entities';
import { ilSchoolsDataSelector } from 'store/state/selectors/insights/schools';

const mapStateToProps = (state: State) => ({
  localData: resolvedLocalPageSelector(state),
  activeInsightId: activeInsightIdSelector(state),
  schoolsData: ilSchoolsDataSelector(state),
  poi: listingPoiSelector(state),
  total: searchListTotalSelector(state),
  route: routeSelector(state),
  searchArea: resolvedStrictLocalDocSelector(state),
  isSearchLoading: isSearchListLoadingSelector(state),
  pricesItemsCount: pricesItemsCountSelector(state),
  madadAgencies: localPageMadadAgenciesCardsSelector(state),
  articles: articlesSelector(state),
  leadingAgents: leadingAgentsByDocIdsSelector(state, LeadingAgentFeature.InfoPagesCarrousel),
});

export default connect(mapStateToProps)(HoodPage);
